export default __webpack_public_path__ + "static/media/ico-person.b611c70c.svg";